module.exports = __webpack_public_path__ + "img/img_05.5354c842.jpg";